export default __webpack_public_path__ + "static/media/nr.1f7cfffb.svg";